import {
  apiRequest, postApiRequest, putApiRequest, deleteApiRequest,
} from './_tools';

export function fetchApps({ page, itemsPerPage, sort, filter, role }) {
  return apiRequest(`/api/apps?page=${page}&itemsPerPage=${itemsPerPage}&role=${role}` +
    `&sortKey=${sort.key}&order=${sort.order}&id=${filter.id}&publisherId=${filter.publisherId}` +
    `&publisherName=${filter.publisherName}&publisherEmail=${filter.publisherEmail}` +
    `&os=${filter.os}&name=${filter.name}&isLive=${filter.isLive}&category=${filter.category}&status=${filter.status}`)
    .catch(({ error }) => Promise.reject(error));
}

export function parseAppFromUrl(url) {
  return apiRequest(`/api/apps/parse?url=${url}`)
    .catch(({ error }) => Promise.reject(error));
}

export function addApp(app) {
  return postApiRequest('/api/apps', app)
    .catch(({ error }) => Promise.reject(error));
}

export function updateApp(app) {
  return putApiRequest(`/api/apps/${app._id}`, app)
    .catch(({ error }) => Promise.reject(error));
}

export function fetchAppDetails(appId) {
  return apiRequest(`/api/apps/${appId}`)
    .catch(({ error }) => Promise.reject(error));
}

export function fetchAppsNames() {
  return apiRequest('/api/apps/names')
    .catch(({ error }) => Promise.reject(error));
}

export function updateUnitStatus({ appId, unitId, active }) {
  return postApiRequest(`/api/apps/${appId}/units/${unitId}/status`, { active })
    .catch(({ error }) => Promise.reject(error));
}

export function updatePostback({ appId, postback, unitId }) {
  return postApiRequest(`/api/apps/${appId}/units/${unitId}/postback`, postback)
    .catch(({ error }) => Promise.reject(error));
}

export function addPlacement({ appId, unitId, placement }) {
  return postApiRequest(`/api/apps/${appId}/units/${unitId}/placements`, placement)
    .catch(({ error }) => Promise.reject(error));
}

export function updatePlacement({ appId, unitId, placementId, placement }) {
  return putApiRequest(`/api/apps/${appId}/units/${unitId}/placements/${placementId}`, placement)
    .catch(({ error }) => Promise.reject(error));
}

export function deletePlacement({ appId, unitId, placementId }) {
  return deleteApiRequest(`/api/apps/${appId}/units/${unitId}/placements/${placementId}`)
    .catch(({ error }) => Promise.reject(error));
}

export function updatePlacementStatus({ appId, unitId, placementId, active }) {
  return postApiRequest(
    `/api/apps/${appId}/units/${unitId}/placements/${placementId}/status/${active}`)
    .catch(({ error }) => Promise.reject(error));
}

export function updateSurveyPromotion({ appId, unitId, surveyPromotion }) {
  return postApiRequest(
    `/api/apps/${appId}/units/${unitId}/surveyPromotion`, { surveyPromotion })
    .catch(({ error }) => Promise.reject(error));
}

export function createApiRequest({ appId, unitId, placementId, apiRequest: request }) {
  return postApiRequest(
    `/api/apps/${appId}/units/${unitId}/placements/${placementId}/apiRequest`,
    { apiRequest: request }
  )
    .catch(({ error }) => Promise.reject(error));
}




/** WEBPACK FOOTER **
 ** ./js/core/api/apps.js
 **/